module.exports = __webpack_public_path__ + "img/title.c1f471f9.png";